var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRumble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    baseProfile: "tiny",
    overflow: "visible",
    viewBox: "0 0 30.1 31.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#85C742",
    d: "M18.1 17.5c1.2-1 1.2-2.8 0-3.8-1.7-1.4-3.6-2.6-5.6-3.6-1.4-.7-2.9.3-3.1 1.8-.4 2.5-.4 4.9-.2 7.2.1 1.6 1.7 2.5 3.1 1.9 2.1-.9 4-2 5.8-3.5zm9-7c2.6 2.9 2.6 7.3 0 10.2-4.5 5-10.4 8.5-17 10.1-3.5.9-7-1.2-8-4.6-2-6.7-1.7-14.3.2-21.1 1-3.5 4.3-5.8 7.8-5 6.4 1.6 12.4 5.5 17 10.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRumble);
export default __webpack_public_path__ + "static/media/rumble.6bde68a3d7e92d6243c5217471c36557.svg";
export { ForwardRef as ReactComponent };